import { useProject } from '@haohan/clw-store'
import { filter, has } from 'lodash-es'

interface RouterParams {
  pageId: string
  preFix?: string
  projectId?: string
  moduleId?: string
}

//获取预览跳转路由
export function getRouterPushUrl(parmas: RouterParams) {
  const projectStore = useProject()
  const preFix = parmas.preFix || 'preview'
  const projectId = parmas.projectId || projectStore.currentProject.id
  const moduleId =
    parmas.moduleId || projectStore.currentModule.id || projectStore.currentModuleList[0].id
  const pageId = parmas.pageId
  if (!pageId) {
    throw new Error('pageId is required')
  }
  const url = `/${preFix}/${projectId}/${moduleId}/${pageId}`
  return url
}
/**
 * 获得首页
 * @param pages 菜单集合
 * @returns 首页
 */
export const getPreviewPage = (pages: any[]) => {
  const p = findFirstPage(filter(pages, (p) => p.name !== 'ROOT' && p.title !== '非菜单页面'))
  return p
}
function findFirstPage(pages: any): any {
  let page
  for (let i = 0; i < pages.length; i++) {
    if (
      pages[i].type === 'PAGE' &&
      (!has(pages[i], 'hidden') || (has(pages[i], 'hidden') && !pages[i].hidden))
    ) {
      page = pages[i]
      break
    } else if (pages[i].children && pages[i].children.length > 0) {
      page = findFirstPage(pages[i].children)
      if (page) {
        break
      }
    }
  }
  return page
}
